function now() {
  return new Date();
}

function timeToUnix(time) {
  return new Date(`1970-01-01T${time}Z`).getTime() / 1000;
}

export default {
  now,
  timeToUnix,
};
